import { useState, useEffect } from 'react';
import { helperService } from '../../../services/helperService';
import { realtimeService } from '../../../services/realtimeService';

export const useHelperBooking = (location) => {
  const [selectedHelper, setSelectedHelper] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadHelper = async () => {
      setLoading(true);
      setError('');
      
      try {
        if (location?.state?.selectedHelper) {
          setSelectedHelper(location?.state?.selectedHelper);
        } else {
          const { data, error: fetchError } = await helperService?.getHelpers({ availabilityStatus: 'available-now' });
          
          if (fetchError) {
            setError(fetchError?.message || 'Failed to load helper');
            return;
          }
          
          if (data && data?.length > 0) {
            setSelectedHelper(data?.[0]);
          } else {
            setError('No helpers available at this time');
          }
        }
      } catch (err) {
        setError(err?.message || 'An error occurred');
      } finally {
        setLoading(false);
      }
    };
    
    loadHelper();

    const subscription = realtimeService?.subscribeToHelperAvailability((payload) => {
      const { eventType } = payload;
      if (eventType === 'INSERT' || eventType === 'UPDATE' || eventType === 'DELETE') {
        console.log('Availability updated in real-time');
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [location?.state]);

  return { selectedHelper, loading, error };
};